import { version } from "~/package.json";

import type {
  PageInfoTrackingState,
  PageViewPayload,
} from "~/types/usePageViewTracking";

export default (type: string | undefined) => {
  const route = useRoute();
  const { locale } = useI18n();
  const { public: publicConfig } = useRuntimeConfig();

  const pageInfoTrackingStateDefaults: PageInfoTrackingState = {
    page: {
      path: "",
      referrer: "",
      url: "",
      type: "",
      ecommerceStage: "",
      cmsTitle: "",
      title: "",
      language: "",
    },
    software: {
      environment: publicConfig.stage || "unknown",
      framework: "nuxt3",
      version: version,
    },
  };

  const trackingState = useState<PageInfoTrackingState>(
    "pageInfoTracking",
    () => pageInfoTrackingStateDefaults,
  );

  const preparePageData = (payload: PageViewPayload): PageInfoTrackingState => {
    const previousUrlFromState = trackingState.value.page.url;
    const initialDocumentReferrer = document.referrer;
    const currentReferrer =
      previousUrlFromState ||
      (previousUrlFromState === "" ? initialDocumentReferrer : "") ||
      "";

    return {
      page: {
        title: payload.title || "unknown",
        cmsTitle: payload.cmsTitle || "unknown",
        type: type || "unknown",
        ecommerceStage: payload.ecommerceStage || "unknown",
        path: route.path,
        referrer: currentReferrer.split("?")[0] || "",
        url: window.location.href,
        language: locale.value,
      },
      software: toRaw(trackingState.value.software),
    } as PageInfoTrackingState;
  };

  const updateStateForNextPage = (currentData: PageInfoTrackingState) => {
    trackingState.value.page.url = currentData.page.url;
    trackingState.value.page.referrer = currentData.page.referrer;
    trackingState.value.page.language = currentData.page.language;
    trackingState.value.page.title = currentData.page.title;
  };

  function trackPageView(payload: PageViewPayload) {
    if (import.meta.server) return;

    const preparedData = preparePageData(payload);

    window.cmtr.pageView(preparedData);
    updateStateForNextPage(preparedData);
  }

  return { trackPageView };
};
